import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=6dc7b518&scoped=true&"
import script from "./FooterMain.vue?vue&type=script&lang=ts&"
export * from "./FooterMain.vue?vue&type=script&lang=ts&"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=6dc7b518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7b518",
  null
  
)

export default component.exports